import ListAllMessages from './ListAllMessages';

export default ListAllMessages;